// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"20b57cfd","195":"d5e06060","422":"5de607cc","623":"ed73235d","753":"f59c9e19","873":"5237fe6e","987":"ec43775e"}[chunkId] + ".chunk.js";
};